import { faNewspaper } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useRef } from 'react'
import Style from './LisenceHolder.module.css'
const LisenceHolder = ({item}) => {
    const textAreaRef = useRef(null)
    function copyToClipboard() {
        textAreaRef.current.select();
        document.execCommand('copy')
    };
    return (
        <div className={`shadow  ${Style.LicesneHolder}`}>
                    <h3><FontAwesomeIcon icon={faNewspaper} className='m-1'/> {item.name}</h3>
                    <div className={Style.BtnHolder}>
                        <p>لایسنس شما:</p>
                        <p className={Style.CopyBtn} onClick={copyToClipboard}>کپی</p>
                    </div>
                    <div className={Style.LicenseText}>
                        <textarea ref={textAreaRef}>{item.sp_key}</textarea>
                    </div>
                </div>
    )
}

export default LisenceHolder
